// extracted by mini-css-extract-plugin
export var attachment = "_sr-a";
export var emailContainer = "_sr-4";
export var emailContentPaddedContainer = "_sr-b";
export var emailHeader = "_sr-6";
export var emailIframe = "_sr-3";
export var emailInfoIcon = "_sr-9";
export var emailShortenedSummary = "_sr-e";
export var infoDropdown = "_sr-0";
export var infoRowBoundedContent = "_sr-d";
export var internal = "_sr-5";
export var merchant = "_sr-8";
export var messageInputContainer = "_sr-h";
export var normal = "_sr-7";
export var replyCard = "_sr-f";
export var subtleButton = "_sr-1";
export var subtleButtonIconContainer = "_sr-2";
export var toggleViewRepliesButton = "_sr-c";
export var wrappingText = "_sr-g";